import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/system/processesaction',
    name: 'POST_PROCESS_ACTION',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
